// flow weak

import { createStore, applyMiddleware, compose } from "redux";
import thunkMiddleware from "redux-thunk";
import { routerMiddleware } from "react-router-redux";
// import createHistory from "history/createHashHistory";
import createHistory from "history/createBrowserHistory";
import reducer from "../reducers/mainReducers";
import fetchMiddleware from "../middleware/fetchMiddleware";
import { localStorageManager } from "../middleware";

export const history = createHistory();

const enhancer = compose(
  applyMiddleware(
    localStorageManager,
    routerMiddleware(history),
    thunkMiddleware,
    fetchMiddleware
  )
);

export default function configureStore(initialState) {
  const store = createStore(reducer, initialState, enhancer);
  return store;
}



// WEBPACK FOOTER //
// ./src/app/redux/store/configureStore.prod.js